import React, { FC } from 'react';
import {
  ModalStyled,
} from './style';
import { campanha, campanhaToSend } from 'models/campanhas';
import ButtonGroup from 'components/ButtonGroup/button-group';
import campanhaService from 'services/campanha-service/campanha-service';
import { UseCampanhaContext } from 'context/campanha-context';

interface ModalProps {
  selected: campanha | campanhaToSend;
  setOpen: (boolean) => void;
  open: boolean;
}

const CampaignDeleteModal: FC<ModalProps> = ({
  selected,
  setOpen,
  open,
}) => {
  const { setRefreshList, setIsLoading } = UseCampanhaContext();

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      await campanhaService.deleteCampanha(selected['id-campanha']);
      setOpen(false);
      setRefreshList(true);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  return (
    <ModalStyled
      show={open}
      onHide={() => { setOpen(false); }}
      centered
      dialogClassName="modal-328"
      backdrop={true}
    >
      <ModalStyled.Header>
        <ModalStyled.Title className="modal-title">
          Confirmar exclusão de
          <br />
          {selected['nome-campanha']}?
        </ModalStyled.Title>
      </ModalStyled.Header>
      <ModalStyled.Body>
        <ButtonGroup
          justify='center'
          label={{
            backButton: 'Cancelar',
            fowardButton: 'Confirmar',
          }}
          onClickCancel={() => {
            setOpen(false);
          }}
          onClickFoward={handleDelete}
          buttonRadius={5}
          buttonPadding='6px 24px'
        />
      </ModalStyled.Body>
    </ModalStyled>
  );
};

export default CampaignDeleteModal;
